import {connect, useSelector} from "react-redux";
import {
    CButton,
    CButtonGroup,
    CCol, CForm,
    CFormInput,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import React, {useEffect, useState} from "react";
import * as api from "../../../api/api";
import {selectedActions} from "../../../redux-store/actions/selected";
import {storeActions} from "../../../redux-store/actions/store";
import * as o2Api from "../../../api/api";

const StoreCornerListWhere = (props) => {
    const {user} = props.account;
    const [company, setCompany] = useState([{cmpCd: "", cmpNm: "전체"}]);
    const [brand, setBrand] = useState([{brandCd: "", brandNm: "전체"}]);
    const [store, setStore] = useState([{storeCd: "", storeNm: "전체"}]);
    const [corner, setCorner] = useState([{cornerCd: "", cornerNm: "전체"}]);
    const [searchStore, setSearchStore] = useState("");

    useEffect(() => {
        getCompany();
    }, []);

    const getCompany = async () => {
        if (user.cmpCd !== null) {
            const {data: result} = await api.getCompany(user.cmpCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([responseBody]);

                props.setSelectCmpCd(user.cmpCd);
                props.onSelect(user.cmpCd, "C");
                getBrand(user.cmpCd);
            }
        }
        else {
            const params = {
                userId: user.userId
            }

            const {data: result} = await api.getCompanyList(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([{cmpCd: "", cmpNm: "전체"}]);
                setCompany((state) => state.concat(responseBody));

                setBrand([{brandCd: "", brandNm: "전체"}]);
                setStore([{storeCd: "", storeNm: "전체"}]);
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        }
    };

    const getBrand = async (cmpCd) => {
        if (user.brandCd !== null) {
            const {data: result} = await api.getBrand(user.cmpCd, user.brandCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setBrand([responseBody]);

                props.onSelect(user.brandCd, "B");
                props.setSelectBrandCd(user.brandCd);
                getStore(user.cmpCd, user.brandCd);
            }
        }
        else {
            const {data: result} = await api.getBrandList(cmpCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setBrand([{brandCd: "", brandNm: "전체"}]);
                setBrand((state) => state.concat(responseBody));

                setStore([{storeCd: "", storeNm: "전체"}]);
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        }
    };

    const getStore = async (cmpCd, brandCd) => {
        if (user.storeCd !== null) {
            const params = {
                cmpCd: user.cmpCd,
                brandCd: user.brandCd,
                storeCd: user.storeCd,
                manageDiv: "0",
                userId: user.userId
            };

            const {data: result} = await api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    setStore(responseBody);

                    props.onSelect(user.storeCd, "S");
                    props.setSelectStoreCd(user.storeCd);
                }
            }
        } else {
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                manageDiv: "0",
                userId: user.userId
            };

            const {data: result} = await api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    setStore([{storeCd: "", storeNm: "전체"}]);
                    setStore((state) => state.concat(responseBody));
                    setCorner([{cornerCd: "", cornerNm: "전체"}]);
                }
            }
        }
    };

    const getCorner = async (cmpCd, brandCd, storeCd) => {
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd
        };

        const {data: result} = await o2Api.getStoreCorner(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            if (responseBody != null) {
                // 성공
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
                setCorner((state) => state.concat(responseBody));
            }
        }
    };

    const handleSelect = (e, value) => {
        console.log("### value :: ", value);
        if (value === "C") {
            props.onSelect(e.target.value, "C");
            props.setSelectCmpCd(e.target.value);
            console.log("### brand :: ", brand);

            if (e.target.value !== '') {
                getBrand(e.target.value);
            }
            else {
                props.setSelectBrandCd("");
                setBrand([{brandCd: "", brandNm: "전체"}]);
                props.setSelectStoreCd("");
                setStore([{storeCd: "", storeNm: "전체"}]);
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "B") {
            props.onSelect(e.target.value, "B");
            props.setSelectBrandCd(e.target.value);
            if (e.target.value !== '') {
                getStore(props.selected.cmpCd, e.target.value);
            }
            else {
                props.setSelectStoreCd("");
                setStore([{storeCd: "", storeNm: "전체"}]);
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "S") {
            props.onSelect(e.target.value, "S");
            props.setSelectStoreCd(e.target.value);
            if (e.target.value !== '') {
                getCorner(props.selected.cmpCd, props.selected.brandCd, e.target.value)
            }
            else {
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "O") {
            props.onSelect(e.target.value, "O");
        }
    };

    return (
        <div className={"row row-cols-lg-auto g-1 m-0"}>
            <CCol xs={12} md={6}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 80}}>운영사</CInputGroupText>
                    <CFormSelect id="company"
                                 value={user.cmpCd ? user.cmpCd : props.selected.cmpCd}
                                 onChange={(e) => handleSelect(e, "C")}>
                        {company.map((item, index) => {
                            return (
                                <option key={index} value={item.cmpCd}>[{item.cmpCd}] {item.cmpNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            <CCol xs={12} md={6}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 80}}>휴게소</CInputGroupText>
                    <CFormSelect id="brand"
                                 value={user.brandCd ? user.brandCd : props.selected.brandCd}
                                 onChange={(e) => handleSelect(e, "B")}>
                        {brand.map((item, index) => {
                            return (
                                <option key={index} value={item.brandCd}>[{item.brandCd}] {item.brandNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            {(props.type === "S" || props.type === "O") &&
            <CCol xs={12} md={6}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 80}}>매장</CInputGroupText>
                    <CFormSelect id="store"
                                 value={user.storeCd ? user.storeCd : props.selected.storeCd}
                                 onChange={(e) => handleSelect(e, "S")}>
                        {store.map((item, index) => {
                            return (
                                <option key={index} value={item.storeCd}>[{item.storeCd}] {item.storeNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            }
            {(props.type === "O") &&
            <CCol xs={12} md={6}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 80}}>코너</CInputGroupText>
                    <CFormSelect id="corner"
                                 value={props.selected.cornerCd}
                                 onChange={(e) => handleSelect(e, "O")}>
                        {corner.map((corner, index) => {
                            return (
                                <option key={index} value={corner.cornerCd}>[{corner.cornerCd}] {corner.cornerNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectCmpCd: (cmpCd) => {
            dispatch(selectedActions.setSelectCmpCd(cmpCd));
        },
        setSelectBrandCd: (brandCd) => {
            dispatch(selectedActions.setSelectBrandCd(brandCd));
        },
        setSelectStoreCd: (storeCd) => {
            dispatch(selectedActions.setSelectStoreCd(storeCd));
        },
        setStore: (store) => {
            dispatch(storeActions.setStore(store));
        }
    }
}

export default connect(null, mapDispatchToProps)(StoreCornerListWhere);
